
import React, { Fragment } from 'react'

import routes from 'routes/public/library'


export default () =>
  <Fragment>
    { routes }
  </Fragment>